/**
 * This object defines a set of constraints on a student's plan to dictate whether
 * or not a given plan satisfies graduation requirements.
 *
 * Very much not optimal, just quick WIP
 */
const muhsdRequirements = {
  gradCredits : [
    {
      id    : '-History-&-Social-Studies',
      years : 4
    },
    {
      id    : '-Art-&-World-Language',
      years : 2
    },
    {
      id    : '-English',
      years : 4
    },
    {
      id    : '-Mathematics',
      years : 2
    },
    {
      id         : '-Electives',
      years      : 6,
      useSurplus : true,
    },
    {
      id    : '-Science',
      years : 3
    },
    // {
    //   id    : '-Science-Life-Science',
    //   years : 1
    // },
    // {
    //   id    : '-Science-Physical-Science',
    //   years : 1
    // },
    {
      id    : '-Physical-Education',
      years : 2
    },
    {
      id    : '-CTE',
      years : 2
    }
  ],
  courses : [
    {
      // not final
      type  : 'REQ_CAPSTONE',
      field : 'cteCourseType',
      value : 'Capstone Course',
    },
    {
      type  : 'LIFE_SCIENCE',
      field : 'gradCreditLabels',
      value : 'Life Science',
    },
    {
      type  : 'PHYSICAL_SCIENCE',
      field : 'gradCreditLabels',
      value : 'Physical Science',
    }
  ],
  years : [
    {
      year    : 'freshman',
      courses : 7
    },
    {
      year    : 'sophomore',
      courses : 7
    },
    {
      year    : 'junior',
      courses : 5
    },
    {
      year    : 'senior',
      courses : 5
    },
  ]
};

export default muhsdRequirements;
